export const DEFAULT_HEADER_WIDTH = 60;
export const MIN_BOUNDS_PADDING = 8;
export const DEFAULT_WORKWEEKDAYS = 127; // Bit mask of 2^7
